import { render, staticRenderFns } from "./NewsList.vue?vue&type=template&id=cad7fbb0"
import script from "./NewsList.js?vue&type=script&lang=js&external"
export * from "./NewsList.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports